export interface PageSizeOption {
  value: number
  title: string
}

const pageSizeOptions: Array<PageSizeOption> = [
  { value: 10, title: '10' },
  { value: 25, title: '25' },
  { value: 50, title: '50' }
]

export default pageSizeOptions
